import React from 'react';
import { useT } from '../../contexts/LocaleContext.jsx';
import '../../styles/partial/FiveDotLoader.css';

function FiveDotLoader({ className = '', ariaLabel }) {
  const t = useT();
  const rootClassName = `five-dot-loader ${className}`.trim();
  // Callers pass an already-translated label; without one the generic
  // "Loading" from the catalog names the status region.
  const label = ariaLabel ?? t('common.status.loadingLabel');

  return (
    <div className={rootClassName} role="status" aria-live="polite" aria-label={label}>
      <span className="five-dot-loader-dot dot-1" />
      <span className="five-dot-loader-dot dot-2" />
      <span className="five-dot-loader-dot dot-3" />
      <span className="five-dot-loader-dot dot-4" />
      <span className="five-dot-loader-dot dot-5" />
    </div>
  );
}

export default FiveDotLoader;